import React, { useState, useEffect } from 'react'
import Reusabletable from '../../../register/FormInputs/reusableforms/Reusabletable'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import files from "./../../../../assets/templates/global_template/client_and_unit_holiday_list.xlsx"
import { getCurrentMonth } from './../../../../services/global_redux/globale_actions/Currentmonth.action'
import { getClient_unit_wise_holidays, updateClient_unit_wise_holidaysById, deleteClient_unit_wise_holidaysById, uploadClient_unit_wise_holidaysFile, multiDeleteClient_unit_wise_holidaysapi } from './../../../../services/global_redux/globale_actions/Client_unit_wise_holidays.action';
import {getHolidays}  from './../../../../services/global_redux/globale_actions/Holidays.action';
import { getUserRole} from "./../../../../services/global_redux/globale_actions/Role.action"
import EditableTable from '../../../reUsableTemplates/EditableTable/EditableTable'
import ImportFileform from '../../../reUsableTemplates/ImportFileform/ImportFileform'
import mainicon from "../../../../assets/global_assets/holiday_table/table_main_icon.png"

function ClientUnitWiseHolidays({ setLoading, showSnackbar }) {
    const [getData, setGetData] = useState([])
    const [file, setFile] = useState([])
    const [editableRow, setEditableRow] = useState(null);
    const [editedValues, setEditedValues] = useState({})
    const [useMonth, setUseMonth] = useState([]);
    const [useHolidays, setUseHolidays] = useState([]);
    const dispatch = useDispatch();
    const { date } = useParams();
    const [checkCreate, setCheckCreate] = useState(false);
    const [checkEdit, setCheckEdit] = useState(false);
    const [checkDelete, setCheckDelete] = useState(false);
    const [selectedclient, setSelectedclient] = useState("");
    const [filteredData, setFilteredData] = useState(getData);

    const header = [
        { key: "hol_name", value: "Holiday Name", input: "holiday" },
        { key: "hol_date", value: "Holiday Date", input: "date" ,readOnly:true },
        { key: "client_id", value: "Organization ID", input: "text" , readOnly:true },
        { key: "unit_id", value: "Branch ID", input: "text" , readOnly:true },
        { key: "year", value: "Current Year", input: "text", readOnly:true },
    ];

    const [actionChecked, setActionChecked] = useState("");
    

    const fetchcurrmonth = async () => {
        try {
            const response = await dispatch(getCurrentMonth());
            const currentMonth = new Date(response.data[0].current_month);
            const currentYear = getYearFromDate(currentMonth);
            setUseMonth(currentYear);
            fetchHolidays(currentYear);
        } catch (err) {
            console.error("Failed to fetch current month:", err);
        }
    };

    const fetchHolidays = async (currentYear) => {
        try {
            const response = await dispatch(getHolidays(currentYear));
            setUseHolidays(response.data);
        } catch (err) {
            console.error("Failed to fetch current month:", err);
        }
    };
    const getYearFromDate = (date) => {
        if (date instanceof Date && !isNaN(date)) {
            return date.getFullYear();
        } else {
            console.error("Invalid Date object provided.");
            return null;
        }
    };

    const fetchdata = async () => {
            try {
                const response = await dispatch(getClient_unit_wise_holidays());
                let mainIndex = 1;
                const transformedData = response.data.flatMap((holiday) =>
                    Array.isArray(holiday.holiday_ids) && Array.isArray(holiday.hol_names)
                        ? holiday.holiday_ids.map((id, index) => ({
                            new_id: id,
                            hol_name: holiday.hol_names[index] || "",
                            hol_date: holiday.hol_date[index] || "",  // fallback in case mismatch
                            index: index,
                            unit_id: holiday.unit_id,
                            year: holiday.year,
                            client_id: holiday.client_id,
                            row_id: holiday.id,
                            id: mainIndex++,
                            old_id: id
                        }))
                        : []
                );
                setGetData(transformedData);
                setFilteredData(transformedData);
                setLoading(false);
            } catch (err) {
                console.error("Failed to fetch holiday data:", err);
                setLoading(false);
            }
    };

    const filterClinetWiseData = (event) => {
        const value = event.target.value;
        setSelectedclient(value);
      
        if (value === "") {
          setFilteredData(getData); 
        } else {
          setFilteredData(getData.filter(item => item.client_id === value));
        }
      };
    useEffect(() => {
        if (useMonth) {
            fetchcurrmonth();
            fetchdata();
            fetchHolidays(useMonth);
        }
    }, [useMonth,dispatch]);

    // const handleFileUpload = async () => {
    //     if (file) {
    //         setLoading(true);

    //         const formData = new FormData();
    //         formData.append('file', file);
    //         try {
    //             const response = await dispatch(uploadClient_unit_wise_holidaysFile(formData));
    //             console.log("error",response);

    //             if (response.success == true) {
    //                 showSnackbar(response.message.data.data.message, 'success');
    //                 setLoading(false);
    //                 fetchdata();
    //                 setFile(null);
    //             } else {

    //                 showSnackbar(response.message.error, 'warning');
    //                 setLoading(false);
    //             }
    //         } catch (error) {
    //             showSnackbar('An error occurred', 'error');
    //             setLoading(false);
    //         }
    //     }
    // };



const downloadBase64Excel = (contentBase64, filename) => {
    try {
        // Decode base64 to binary
        const byteCharacters = atob(contentBase64);
        const byteNumbers = new Array(byteCharacters.length);
        
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        
        // Create download link
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename || 'client_unit_wise_holidays_failed_rows.xlsx';
        document.body.appendChild(a); // Required for Firefox
        a.click();
        
        // Cleanup
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        
        console.log('Error file downloaded successfully:', filename);
    } catch (e) {
        console.error('Download failed:', e);
        showSnackbar('Failed to download error file. Please try again.', 'error');
    }
};

const handleFileUpload = async () => {
    if (!file) {
        showSnackbar('Please select a file to upload', 'warning');
        return;
    }
    
    setLoading(true);
    
    try {
        const response = await dispatch(uploadClient_unit_wise_holidaysFile(file));
        console.log("Upload client unit wise holidays response:", response);
        
        // ============================================================
        // HANDLE SUCCESS RESPONSE (status 200)
        // ============================================================
        if (response.success === true) {
            const data = response.data; // This is the backend response object
            
            setActionChecked("create");
            // Check if we have the expected response structure
            if (!data) {
                showSnackbar('Unexpected response format', 'error');
                setLoading(false);
                return;
            }
            
            // Extract counts
            const insertedCount = data.inserted_count || 0;
            const failedCount = data.failed_count || 0;
            const totalRows = insertedCount + failedCount;
            
            // CASE 1: Full success (all rows inserted)
            if (insertedCount > 0 && failedCount === 0) {
                showSnackbar(
                    data.message || `Successfully uploaded ${insertedCount} record(s)`, 
                    'success'
                );
                
                // Refresh the data table
                fetchdata();
                setFile(null);
            }
            
            // CASE 2: Partial success (some rows inserted, some failed)
            else if (insertedCount > 0 && failedCount > 0) {
                showSnackbar(
                    `Partial upload: ${insertedCount} of ${totalRows} record(s) added successfully. ` +
                    `${failedCount} record(s) failed. Downloading error file...`,
                    'warning',
                    6000 // Show for 6 seconds
                );
                
                // Download error file
                if (data.error_file && data.error_file.content_base64) {
                    downloadBase64Excel(
                        data.error_file.content_base64, 
                        data.error_file.filename
                    );
                } else {
                    console.warn('No error file in response despite failed rows');
                }
                
                // Refresh the data table (to show successfully inserted rows)
                fetchdata();
                // Don't clear the file - user might want to fix and re-upload
            }
            
            // CASE 3: Complete failure (all rows failed)
            else if (insertedCount === 0 && failedCount > 0) {
                showSnackbar(
                    `Upload failed: All ${failedCount} record(s) have validation errors. ` +
                    `Downloading error file with details...`,
                    'error',
                    6000
                );
                
                // Download error file
                if (data.error_file && data.error_file.content_base64) {
                    downloadBase64Excel(
                        data.error_file.content_base64, 
                        data.error_file.filename
                    );
                } else {
                    console.warn('No error file in response despite all rows failing');
                    // Fallback: show the message if available
                    if (data.message) {
                        showSnackbar(data.message, 'error', 8000);
                    }
                }
            }
            
            // CASE 4: Unexpected state (shouldn't happen but handle gracefully)
            else {
                showSnackbar(
                    data.message || 'Upload completed with unexpected result', 
                    'info'
                );
            }
            
            setLoading(false);
        }
        
        // ============================================================
        // HANDLE ERROR RESPONSE (non-200 status)
        // ============================================================
        else {
            const errorMsg = response.error || 'Upload failed';
            
            // Handle different error types
            if (typeof errorMsg === 'string') {
                showSnackbar(errorMsg, 'error');
            } else if (Array.isArray(errorMsg)) {
                // If backend returns array of errors
                const displayError = errorMsg.slice(0, 3).join('; ') + 
                    (errorMsg.length > 3 ? ` ... and ${errorMsg.length - 3} more errors` : '');
                showSnackbar(displayError, 'error');
            } else if (typeof errorMsg === 'object' && errorMsg.error) {
                showSnackbar(errorMsg.error, 'error');
            } else {
                showSnackbar('An error occurred during upload', 'error');
            }
            
            setLoading(false);
        }
        
    } catch (error) {
        // This catches any unexpected errors in the frontend code
        console.error('Upload error:', error);
        showSnackbar('An unexpected error occurred. Please try again.', 'error');
        setLoading(false);
    }
};


    const submitdelete = async (idsdata) => {
        setLoading(true);
        const idArray = idsdata.ids || [];
        const deleteDataList = idArray.map(id => {
            const item = getData.find(d => d.id === id);
            return {
                row_id: item?.row_id,
                holiday_id: item?.old_id
            };
        });
        const grouped = deleteDataList.reduce((acc, curr) => {
            const existing = acc.find(e => e.row_id === curr.row_id);
            if (existing) {
                existing.holiday_ids.push(curr.holiday_id);
            } else {
                acc.push({ row_id: curr.row_id, holiday_ids: [curr.holiday_id] });
            }
            return acc;
        }, []);
        try {
            const response = await dispatch(multiDeleteClient_unit_wise_holidaysapi(grouped));
            if (response.success == true) {
                showSnackbar(response.message.message, 'success');
                setLoading(false);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }

    }

    const handleSaveClick = async (e) => {
        setLoading(true);
        try {
            // Create a copy of editedValues without hol_type
            const { hol_type, ...payload } = editedValues;
            const check_data = editedValues.new_id;
            const getdatas = useHolidays.find(holiday => holiday.hol_name === check_data);
            if(!getdatas){
                const response = await dispatch(updateClient_unit_wise_holidaysById(editedValues.row_id, payload));

                if (response.success === true) {
                    showSnackbar(response.message, 'success');
                    setLoading(false);
                    setEditableRow(null);
                    fetchdata();
                } else {
                    showSnackbar(response.message, 'warning');
                    setLoading(false);
                }
            }else{
                showSnackbar("Updated successfully", 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
            }

        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    }


    const handledeleteClickOpenalert = async (id) => {
        setLoading(true);
        const delete_item = getData.find(d => d.id === id);
        try {
            const deleteData = ({
                'row_id': delete_item.row_id,
                'index': delete_item.index,
                'old_id': delete_item.old_id
            })
            const response = await dispatch(deleteClient_unit_wise_holidaysById(delete_item.row_id,deleteData));
            if (response.success == true) {
                showSnackbar(response.message, 'success');
                setLoading(false);
                setEditableRow(null);
                fetchdata();
                setActionChecked("delete");
            } else {
                showSnackbar(response.message, 'warning');
                setLoading(false);
            }
        } catch (error) {
            showSnackbar('An error occurred', 'error');
            setLoading(false);
        }
    };

    const getUserPermission = async () => {
        try {
            const response = await dispatch(getUserRole());
                const rawPermissions = response?.data?.permissions;
                const parsedPermissions = typeof rawPermissions === "string"
                    ? JSON.parse(rawPermissions)
                    : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
                    ? JSON.parse(rawPermissions[0])
                    : rawPermissions;
                parsedPermissions.forEach((item) => {
                  if (item.section == "Configuration" && item.module == "Branch Holidays") {
                              setCheckCreate(item.action.create);
                              setCheckEdit(item.action.edit);
                              setCheckDelete(item.action.delete);
        }})
    
        } catch (err) {
          console.error("Failed to fetch states:", err);
        }

    };
    useEffect(() => {
      getUserPermission();
    }, [dispatch]);
    return (
        <div className='container-fluid '>
            {/* <Reusabletable
                data={getData}
                header={header}
                setFile={setFile}
                handleFileUpload={handleFileUpload}
                submitdelete={null}
                handleSaveClick={handleSaveClick}
                setEditableRow={setEditableRow}
                editableRow={editableRow}
                setEditedValues={setEditedValues}
                editedValues={editedValues}
                handledeleteClickOpenalert={handledeleteClickOpenalert}
                title={'Branch Holidays'}
                setLoading={setLoading}
                filestemp={files}
                showSnackbar={showSnackbar}
                useHolidays = {useHolidays}
                getCreatePermission = {checkCreate}
                getEditPermission = {checkEdit}
                getDeletePermission = {checkDelete}
            /> */}
            {checkCreate &&
                <ImportFileform
                    setFiledata={setFile}
                    title={'Branch Holidays'}
                    filestemp={files}
                    handleFileUpload={handleFileUpload}
                    File={file}
                />
            }
            <EditableTable
            
            header={header}
            mainIcon={mainicon}
            title={'Branch Holidays'}
            data={filteredData}
            setEditableRow={setEditableRow}
            setEditedValues={setEditedValues}
            handledeleteClickOpenalert={handledeleteClickOpenalert}
            editableRow={editableRow}
            setLoading={setLoading}
            editedValues={editedValues}
            getEditPermission = {false}
            getDeletePermission = {checkDelete}
            date={date}
            submitdelete={submitdelete}
            handleSaveClick={handleSaveClick}
            showSnackbar={showSnackbar}  
            actionChecked={actionChecked}
            setActionChecked={setActionChecked}          
            useHolidays = {useHolidays}
            createOrfilterComp=
            {getData &&
              <select className="formsTable_select_dropdown" value={selectedclient}  onChange={filterClinetWiseData} >
            <option value="" className='bg-light text-dark'>All Data</option>
            {[...new Set(getData.map(item => item.client_id))]?.map((client_id, index) => (
              <option key={index} value={client_id} className='bg-light text-dark'>{client_id}</option>
            ))}
          </select>
          }
            />
        </div>
    )
}


export default ClientUnitWiseHolidays
